<kendo-grid class="isg-grid" [data]="dataItems" [height]="heightGrid" [navigable]="true" (add)="onAddRow($event)"
  (save)="onSaveHandler($event)" (remove)="onRemoveHandler($event)" (cancel)="onCancelHandler($event)"
  (cellClick)="onCellClickHandler($event)" (cellClose)="onCellCloseHandler($event)"
  (dataStateChange)="onStateChange($event)" (excelPaste)="onExcelPaste">

  <ng-template kendoGridToolbarTemplate>
    <span>Add New Row</span>
    <button kendoGridAddCommand class="isg-button-icon">
      <span class="fa-regular fa-diagram-next" title="Add new row for user"></span>
    </button>
    <button kendoButton type="button" class="isg-button-icon" (click)="onUsersClearAll()"
      [disabled]="(dataItems.length < 1 )">
      <span class="fas fa-eraser" title="Clear user list"></span>
    </button>
    <button kendoButton type="button" class="isg-button-icon" (click)="onImportUsers()"
      [disabled]="(dataItems.length < 1 )">
      <span class="fas fa-floppy-disk" title="Import and save users"></span>
    </button>
  </ng-template>

  <ng-template kendoGridNoRecordsTemplate>
    <span>Click add new row to add a collection of user records to import. When done click the Save import button to add
      the users to the server.</span>
  </ng-template>

  <kendo-grid-column field="email" title="Email"> </kendo-grid-column>
  <kendo-grid-column field="firstName" title="First Name"> </kendo-grid-column>
  <kendo-grid-column field="alias" title="Alias"> </kendo-grid-column>
  <kendo-grid-column field="lastName" title="Last Name"> </kendo-grid-column>
  <kendo-grid-column field="isSendEmail" title="Send Email" [width]="100">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <input type="checkbox" [checked]="dataItem.isSendEmail" (change)="onSendEmailChange($event, dataItem)" />
    </ng-template>
    <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
      <input type="checkbox" [formControl]="formGroup.get('isSendEmail')" />
    </ng-template>
  </kendo-grid-column> 


  <kendo-grid-command-column title="" [width]="100">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <div class="isg-user-import-actions">
        <button kendoGridRemoveCommand class="isg-button-icon">
          <span class="far fa-trash-alt" title="Remove"></span>
        </button>
        <button kendoGridSaveCommand class="isg-button-icon">
          <span class="fas fa-plus" title="Add user for import"></span>
        </button>
        <button kendoGridCancelCommand class="isg-button-icon">
          <span class="fas fa-xmark" title="Cancel"></span>
        </button>
      </div>
    </ng-template>
  </kendo-grid-command-column>

</kendo-grid>